import PropTypes from 'prop-types';
import React from 'react';
import SurveyIcon from '../SurveyIcon';
import { connect } from 'react-redux';
import { questionKey } from './reducer';
import classnames from 'classnames';

export const ErrorMessages = ({ className, errorMessages = [], style }) =>
  errorMessages.length ? (
    <div
      className={classnames('anim-bounce anim-popover c-red', className)}
      style={style}
    >
      {errorMessages.map((msg, i) => (
        <p key={i} className="mt0">
          <SurveyIcon icon="warning" /> {msg}
        </p>
      ))}
    </div>
  ) : null;

ErrorMessages.propTypes = {
  className: PropTypes.string,
  errorMessages: PropTypes.array,
  style: PropTypes.object,
};

const mapStateToProps = (state, ownProps) => {
  const question = state[questionKey(ownProps)];
  return {
    errorMessages: (question && question.errorMessages) || [],
  };
};

const QuestionErrors = connect(mapStateToProps)(ErrorMessages);

export default QuestionErrors;
